import React from "react";
import { useChannelIOApi } from "react-channel-plugin";
import { Button } from "../../Components/StyledComponents";
import "./ReqWaiting.scss";

const ReqWaiting = () => {
  const { showMessenger } = useChannelIOApi();

  return (
    <div className="req-order">
      <div className="row" style={{marginBottom: 24}}>
        <p className="text">QR코드 하나로 대기 고객 자동 관리&nbsp;</p>
        <p className="title" style={{margin: 0}}>QR웨이팅</p>
      </div>
      <div className="order-desc">
        <div className="row">
            <p className="desc-text">매장 웨이팅 QR코드로 대기고객 자동 관리&nbsp;</p>
            <p className="title-text">QR웨이팅</p>
        <Button
            variant="outline"
            fontSize={14}
            style={{ width: 130, height: 40, padding: 0, marginLeft: 16 }}
            onClick={() =>
            (window.location.href = "https://home.syrupfriends.com/waiting")
            }
        >
            QR웨이팅 구경하기
        </Button>
        </div>
      </div>
      <Button
        variant="sub"
        style={{ width: 114, marginTop: 24 }}
        onClick={showMessenger}
      >
        상담 문의하기
      </Button>
    </div>
  );
};

export default ReqWaiting;
